import { GameConstants } from "./GameConstants";

    
export class Materials {

    public goalkeeperMaterial: Phaser.Physics.P2.Material;
    public frozenGoalkeeperMaterial: Phaser.Physics.P2.Material;
    public pegMaterial: Phaser.Physics.P2.Material;
    public plankMaterial: Phaser.Physics.P2.Material;
    public elasticPegMaterial: Phaser.Physics.P2.Material;
    public ballMaterial: Phaser.Physics.P2.Material;
    public shockAbsorberMaterial: Phaser.Physics.P2.Material;
    public sideWallsMaterial: Phaser.Physics.P2.Material;
    public postMaterial: Phaser.Physics.P2.Material;
    public duckMaterial: Phaser.Physics.P2.Material;

    private game: Phaser.Game;

    constructor(game: Phaser.Game) {

        this.game = game;

        this.shockAbsorberMaterial = this.game.physics.p2.createMaterial(GameConstants.UPPER_SHOCK_ABSORBER);
        this.postMaterial = this.game.physics.p2.createMaterial(GameConstants.POSTS);
        this.goalkeeperMaterial = this.game.physics.p2.createMaterial(GameConstants.GOALKEEPER);
        this.frozenGoalkeeperMaterial = this.game.physics.p2.createMaterial(GameConstants.FROZEN_GOALKEEPER);
        this.pegMaterial = this.game.physics.p2.createMaterial(GameConstants.PEG);
        this.elasticPegMaterial = this.game.physics.p2.createMaterial(GameConstants.ELASTIC_PEG);
        this.ballMaterial = this.game.physics.p2.createMaterial(GameConstants.BALL);
        this.plankMaterial = this.game.physics.p2.createMaterial(GameConstants.PLANK);
        this.duckMaterial = this.game.physics.p2.createMaterial(GameConstants.DUCK);

        // el contacto de los pivotes con la pelota
        const contactMaterialPegBall = this.game.physics.p2.createContactMaterial(this.pegMaterial, this.ballMaterial);
        contactMaterialPegBall.friction = 0.15;
        contactMaterialPegBall.restitution = 0.58;

        // el contacto de los pivotes elasticos con la pelota
        const contactMaterialElasticPegBall = this.game.physics.p2.createContactMaterial(this.elasticPegMaterial, this.ballMaterial);
        contactMaterialElasticPegBall.friction = 0.05;     // Friction to use in the contact of these two materials.
        contactMaterialElasticPegBall.restitution = 2.3;  // era 2.3

        // el contacto del portero con la pelota
        const contactMaterialGoalkeeperBall = this.game.physics.p2.createContactMaterial(this.goalkeeperMaterial, this.ballMaterial);
        contactMaterialGoalkeeperBall.friction = 0.05;     // Friction to use in the contact of these two materials.
        contactMaterialGoalkeeperBall.restitution = 1.75;

        // el portero congelado
        const contactMaterialFrozenGoalkeeperBall = this.game.physics.p2.createContactMaterial(this.frozenGoalkeeperMaterial, this.ballMaterial);
        contactMaterialFrozenGoalkeeperBall.friction = 0.05;     // Friction to use in the contact of these two materials.
        contactMaterialFrozenGoalkeeperBall.restitution = 0;

        // el tope de arriba que absorbe impactos
        const contactMaterialUpperShockAbsorber = this.game.physics.p2.createContactMaterial(this.shockAbsorberMaterial, this.ballMaterial);
        contactMaterialUpperShockAbsorber.friction = 0.2;
        contactMaterialUpperShockAbsorber.restitution = 0.1;

        const contactMaterialSideWall = this.game.physics.p2.createContactMaterial(this.sideWallsMaterial, this.ballMaterial);
        contactMaterialSideWall.friction = 0.2;
        contactMaterialSideWall.restitution = 0.35;

        // con los palos de la porteria
        const contactMaterialPost = this.game.physics.p2.createContactMaterial(this.postMaterial, this.ballMaterial);
        contactMaterialPost.friction = 0.2;
        contactMaterialPost.restitution = 1;

        // los tablones
        const contactMaterialPlank = this.game.physics.p2.createContactMaterial(this.plankMaterial, this.ballMaterial);
        contactMaterialPlank.friction = 0.55;
        contactMaterialPlank.restitution = .52;

        // el patito de goma
        const contactMaterialDuck = this.game.physics.p2.createContactMaterial(this.duckMaterial, this.ballMaterial);
        contactMaterialDuck.friction = 0.55;
        contactMaterialDuck.restitution = 1.75;
    }
}
